import type * as SchemaTypes from '../types';

import type { TranslatedStringDataFragment } from './TranslatedStringData';
import { gql } from '@apollo/client';
import { TranslatedStringDataFragmentDoc } from './TranslatedStringData';
export type SystemMessageData_MaintenanceUpdate_Fragment = (
  { __typename: 'MaintenanceUpdate' }
  & Pick<SchemaTypes.MaintenanceUpdate, 'date' | 'isActive' | 'warningBefore'>
  & { pageTitle: (
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  ), pageContent?: SchemaTypes.Maybe<(
    { __typename: 'TranslatedString' }
    & TranslatedStringDataFragment
  )>, image?: SchemaTypes.Maybe<(
    { __typename: 'UploadedFileWithPreview' }
    & Pick<SchemaTypes.UploadedFileWithPreview, 'url'>
  )>, period: (
    { __typename: 'Period' }
    & Pick<SchemaTypes.Period, 'start' | 'end'>
  ), company: (
    { __typename: 'Company' }
    & Pick<SchemaTypes.Company, 'timeZone'>
  ) }
);

export type SystemMessageData_MessageNotice_Fragment = (
  { __typename: 'MessageNotice' }
  & Pick<SchemaTypes.MessageNotice, 'date' | 'message'>
);

export type SystemMessageData_UserSessionRevoked_Fragment = (
  { __typename: 'UserSessionRevoked' }
  & Pick<SchemaTypes.UserSessionRevoked, 'date' | 'displayNotice'>
);

export type SystemMessageDataFragment = SystemMessageData_MaintenanceUpdate_Fragment | SystemMessageData_MessageNotice_Fragment | SystemMessageData_UserSessionRevoked_Fragment;

export const SystemMessageDataFragmentDoc = /*#__PURE__*/ gql`
    fragment SystemMessageData on SystemMessage {
  __typename
  ... on UserSessionRevoked {
    date
    displayNotice
  }
  ... on MessageNotice {
    date
    message
  }
  ... on MaintenanceUpdate {
    date
    isActive
    pageTitle {
      ...TranslatedStringData
    }
    pageContent {
      ...TranslatedStringData
    }
    image {
      url
    }
    period {
      start
      end
    }
    company {
      timeZone
    }
    warningBefore
  }
}
    `;